import ChatbotPage from "./ChatbotPage"

function App() {
  return (
    <div>
      <ChatbotPage />
    </div>
  )
}

export default App
